import { BecomeAmbassadorMolecule } from '../../molecules/become-ambassador';
import {
  AmbassadorContentHero,
  Route,
  slickCenterModeSettings,
} from '../../../enums';
import { SlickCarouselImagesMolecule } from '../../molecules';
import React from 'react';
import { useAmbassadorMobileStyles } from '../../../styles/templates/ambassador-mobile.styles';

export const AmbassadorHeroOrganism = () => {
  const classes = useAmbassadorMobileStyles();
  return (
    <section className="block w-full">
      <div className={`${classes.ambassadorCarousel}`}>
        <SlickCarouselImagesMolecule
          settings={slickCenterModeSettings}
          images={[
            '/images/ambassadors/slider_3.png',
            '/images/ambassadors/slider_4.png',
            '/images/ambassadors/slider_1.png',
            '/images/ambassadors/slider_2.png',
          ]}
        />
      </div>
      <div className="block mt-5">
        <div className="w-10/12 mx-auto">
          <h2 className="text-large leading-10 w-80 min-w-full ">
            {AmbassadorContentHero.HERO_TITLE}
          </h2>
          <p className="mt-3 lg:mt-4 w-72 min-w-full text-lg leading-6">
            {AmbassadorContentHero.HERO_CONTENT}
          </p>
        </div>
        <div className="w-10/12 mx-auto flex flex-col items-center mt-5 lg:mt-6">
          <BecomeAmbassadorMolecule
            href={Route.JOIN}
            label={AmbassadorContentHero.HERO_CTA}
          />
        </div>
      </div>
    </section>
  );
};
